import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, Table } from "reactstrap";
import { Href, PopularCoinsHeading } from "../../../../utils/Constant";
import PopularCoinsTableHeader from "./PopularCoinsTableHeader";
import PopularCoinsTableBody from "./PopularCoinsTableBody";
import { H3 } from "../../../../AbstractElements";
import { useState } from "react";

const PopularCoins = () => {
  const [tabId,setTabId] = useState("contact")
  return (
    <Col xl="6" className="proorder-xl-13 proorder-lg-13">
      <Card className="coins-table">
        <CardHeader className="card-no-border">
          <H3>{PopularCoinsHeading}</H3>
          <div className="card-header-right">
            <Nav pills tabs className="simple-wrapper" id="myTab">
              <NavItem>
                <NavLink active={tabId === "home" ? true : false} id="home" href={Href} onClick={()=>setTabId("home")}> Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={tabId === "profile" ? true : false} id="profile" href={Href} onClick={()=>setTabId("profile")}>Profile</NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={tabId === "contact" ? true : false} id="contact" href={Href} onClick={()=>setTabId("contact")}>Contact</NavLink>
              </NavItem>
            </Nav>
          </div>
        </CardHeader>
        <CardBody className="pt-0">
          <div className="custom-scrollbar">
            <Table responsive className="display w-100" id="coins-table">
              <PopularCoinsTableHeader />
              <PopularCoinsTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PopularCoins;
